export default function getOS(){
    var userAgent = window.navigator.userAgent.toLowerCase()
    var operatingSystem = "Web"
    if (userAgent.indexOf("android") > -1)
      operatingSystem = "AndroidmWeb"
    else if (/iphone|ipod|ipad/.test(userAgent))
      operatingSystem = "iOSmWeb"
    return operatingSystem;
  }